import { Page, Layout } from "@shopify/polaris";
import { useState, useCallback } from "react";

import ErrorTable from "../componens/errorTable";

export default function errorLog({ canDelete = false }) {
  return (
      <Page>
        <Layout>
          <Layout.Section>
            <ErrorTable canDelete={canDelete} />
          </Layout.Section>
        </Layout>
      </Page>
  );
}
